import { TerminalViewTable } from './components/Table'
import React from 'react'
import { useEffect, useState } from 'react'
import { cancelToken, get } from '@fareye/utils'
import { Flex, styled } from '@fareye/ui'
import { terminalView } from '@fareye/configs'
import { HEADERS } from '@fareye/utils'
import { Header } from './components/Header'
import { useMemo } from 'react'

const TerminalViewContainer: any = styled(Flex)`
  width: 1;
  min-height: 100%;
  height: auto;
  flex-direction: column;
  flex-grow: 1;
  background: ${terminalView.darkTheme.bodyBgColor};
  overflow: hidden;
`
const TerminalViewUpperTableContainer: any = styled(Flex)`
  @media (max-width: 1440px) {
    margin-bottom: 24px;
  }

  @media (min-width: 1441px) and (max-width: 3840px) {
    margin-bottom: 44px;
  }
  @media (min-width: 3841px) {
    margin-bottom: 90px;
  }
`
const TerminalViewTableContainer = styled.div`
  margin-bottom: 50px;
  @media (max-width: 1920px) {
    margin-left: 16px;
    margin-right: 16px;
  }
  @media (min-width: 1920px) and (max-width: 3840px) {
    margin-left: 40px;
    margin-right: 40px;
  }
  @media (min-width: 3840px) {
    margin-left: 120px;
    margin-right: 106px;
  }
`
export const TerminalView = function(props: any) {
  const config = props.config
  const type = config.type || 'b2b'
  const optionsArrivalDeparture = config?.menu?.options
  const { baseUrl } = props
  const [hub, setHub] = useState({ label: '', value: 0 })
  const [arrivalOrDeparture, setArrivalOrDeparture] = useState(
    optionsArrivalDeparture[0] ?? { value: 0 }
  )
  const [pageSize, setPageSize] = useState(
    optionsArrivalDeparture[0].pageSize ?? 5
  )
  const [optionsHub, setOptionsHub] = useState([])
  const [fetchedDataArrival, setFetchedDataArrival] = useState([])
  const [fetchedDataDeparture, setFetchedDataDeparture] = useState([])
  const [arrivalDataLoading, setArrivalDataLoading] = useState(true)
  const [departureDataLoading, setDepartureDataLoading] = useState(true)
  const [refreshData, setRefreshData] = useState(0)

  async function getTableData(
    selectedHub: any,
    apiURL: any,
    setFetchedData: any,
    setLoading: any,
    tableName: any
  ) {
    const sourceRnM = cancelToken().source()
    try {
      setLoading(true)
      const url = `${baseUrl}${apiURL}?hubId=${selectedHub.value}&type=${type}`
      const resp = await get(url, sourceRnM.token)
      const { status, data } = resp
      if (status >= 200 && status < 300) {
        setFetchedData(data.data)
        setLoading(false)
      }
    } catch (e:any) {
      setLoading(false)
      console.error(
        `Could not Fetch Terminal View ${tableName} for hub ${selectedHub.label}`,
        e
      )
    }
  }

  async function getHubOptions(apiURL: any) {
    const sourceRnM = cancelToken().source()
    try {
      const url = `${baseUrl}${apiURL}?type=${type}`
      const resp = await get(url, sourceRnM.token)
      const { status, data } = resp
      if (status >= 200 && status < 300) {
        setOptionsHub(data.data)
        if (data.data.length) {
          setHub(data.data[0])
        } else {
          setArrivalDataLoading(false)
          setDepartureDataLoading(false)
          console.error(`No hubs found for terminal view menu`)
        }
      }
    } catch (e:any) {
      setArrivalDataLoading(false)
      setDepartureDataLoading(false)
      console.error(`Could not fetch Hub Options for Terminal View `, e)
    }
  }

  useEffect(() => {
    getHubOptions(config?.hubList?.apiURL)
  }, [])

  useEffect(() => {
    setFetchedDataArrival([])
    setFetchedDataDeparture([])
    if (hub.value) {
      getTableData(
        hub,
        config?.children?.arrival?.config?.apiConfig?.apiURL,
        setFetchedDataArrival,
        setArrivalDataLoading,
        'arrival'
      )
      getTableData(
        hub,
        config?.children?.departure?.config?.apiConfig?.apiURL,
        setFetchedDataDeparture,
        setDepartureDataLoading,
        'departure'
      )
    }
  }, [hub, refreshData])
  const arrivalTable = useMemo(() => {
    return (
      <TerminalViewTable
        pageSize={pageSize}
        hub={hub.value}
        tableName={config?.children?.arrival?.config?.tableName ?? 'ARRIVALS'}
        tableType={config?.children?.arrival?.config?.tableType ?? 'ARRIVALS'}
        fetchedDataFromApi={fetchedDataArrival}
        columns={config?.children?.arrival?.config?.columns ?? []}
        dataLoading={arrivalDataLoading}
        pageChangeTimeInterval={config?.page?.paginationTimeInterval}
      />
    )
  }, [hub, refreshData, fetchedDataArrival, arrivalDataLoading, config, pageSize])
  const departureTable = useMemo(() => {
    return (
      <TerminalViewTable
        pageSize={pageSize}
        hub={hub.value}
        tableName={config?.children?.departure?.config?.tableName ?? 'DEPARTURES'}
        tableType={config?.children?.departure?.config?.tableType ?? 'DEPARTURES'}
        columns={config?.children?.departure?.config?.columns ?? []}
        fetchedDataFromApi={fetchedDataDeparture}
        dataLoading={departureDataLoading}
        pageChangeTimeInterval={config?.page?.paginationTimeInterval}
      />
    )
  }, [hub, refreshData, fetchedDataDeparture, departureDataLoading, config, pageSize])
  return (
    <TerminalViewContainer column>
      <Header
        optionsHub={optionsHub}
        setHub={setHub}
        setPageSize={setPageSize}
        optionsArrivalDeparture={optionsArrivalDeparture}
        setArrivalOrDeparture={setArrivalOrDeparture}
        setRefreshData={setRefreshData}
        config={config}
      />
      <TerminalViewTableContainer>
        <TerminalViewUpperTableContainer>
          {[0, 2].includes(arrivalOrDeparture.value) && departureTable}
        </TerminalViewUpperTableContainer>
        <TerminalViewUpperTableContainer>
          {[0, 1].includes(arrivalOrDeparture.value) && arrivalTable}
        </TerminalViewUpperTableContainer>
      </TerminalViewTableContainer>
    </TerminalViewContainer>
  )
}
